module.exports = __webpack_public_path__ + "static/img/ysfx1.ae8948d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/ysfx1.png
// module id = 4bgp
// module chunks = 0